// extracted by mini-css-extract-plugin
module.exports = {"title":"BaggagePolicies-module__title___z3cI6","item":"BaggagePolicies-module__item___jc2B7","itemLink":"BaggagePolicies-module__itemLink___g2vSU"};